import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import {ActivityBoundary} from '@github-ui/react-core/activity-boundary'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {ReposOverview} from '@github-ui/repos-overview'
import {SplitPageLayout} from '@primer/react'

import {AskCopilotNoReadmeCard} from '../components/ask-copilot/AskCopilotNoReadmeCard'
import {AskCopilotReadmeMenu} from '../components/ask-copilot/AskCopilotReadmeMenu'
import type {MergedHeaderPayload} from '../components/overview/OverviewHeader'
import {OverviewHeader} from '../components/overview/OverviewHeader'
import {OverviewSidebar} from '../components/overview/OverviewSidebar'
import {useUpdateRefInfoAndPath} from '../hooks/use-update-ref-info-and-path'

export function ReposOverviewPage({
  payload,
  sidebarPayload,
}: {
  payload: DataRouterFileOverviewPayload
  sidebarPayload: MergedHeaderPayload
}) {
  useUpdateRefInfoAndPath(payload.refInfo, payload.path)
  const copilotAccessAllowed = payload.copilotAccessAllowed ?? false

  return (
    <SplitPageLayout className="container-xl">
      <SplitPageLayout.Header padding="none" divider="none" className="tmp-px-3 tmp-px-lg-5">
        <ActivityBoundary enabled>
          <OverviewHeader overview={payload.overview} headerData={sidebarPayload} />
        </ActivityBoundary>
      </SplitPageLayout.Header>
      <SplitPageLayout.Content as="div" padding="condensed">
        <ReposOverview
          payload={payload}
          className="tmp-pl-lg-3 mt-0"
          tree={payload.tree}
          readmeHeaderSlot={
            copilotAccessAllowed && (
              <ErrorBoundary boundaryName="ask-copilot-readme-header" fallback={null}>
                <AskCopilotReadmeMenu />
              </ErrorBoundary>
            )
          }
          noReadmeSlot={
            copilotAccessAllowed && (
              <ErrorBoundary boundaryName="ask-copilot-no-readme-card" fallback={null}>
                <AskCopilotNoReadmeCard />
              </ErrorBoundary>
            )
          }
        />
      </SplitPageLayout.Content>
      <SplitPageLayout.Pane position="end" sticky={false} divider="none" width="large" className="pr-2">
        <ActivityBoundary enabled>
          <OverviewSidebar overview={payload.overview} sidebarPayload={sidebarPayload} />
        </ActivityBoundary>
      </SplitPageLayout.Pane>
    </SplitPageLayout>
  )
}
